"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcScrollerBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_scroller_constants_1 = require("./bc-scroller-constants");
var bc_scroller_constants_2 = require("./bc-scroller-constants");
var bc_scroller_constants_3 = require("./bc-scroller-constants");
var bc_scroller_constants_4 = require("./bc-scroller-constants");
var BcScrollerBehavior = (function (_super) {
    __extends(BcScrollerBehavior, _super);
    function BcScrollerBehavior() {
        var _this = _super.call(this) || this;
        _this.contentPosition = 0;
        _this.scrollerBeingDragged = false;
        return _this;
    }
    BcScrollerBehavior.setUpAll = function () {
        var srollerElements = Array.from(document.querySelectorAll("[class^='".concat(bc_scroller_constants_1.SCROLLER_SCROLLABLE_CLASS, "']")));
        var elements = [];
        for (var _i = 0, srollerElements_1 = srollerElements; _i < srollerElements_1.length; _i++) {
            var element = srollerElements_1[_i];
            var bc = new BcScrollerBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    };
    BcScrollerBehavior.prototype._setUp = function () {
        var content = this.mySelf.querySelector("[class='".concat(bc_scroller_constants_2.SCROLLER_SCROLLABLE_CONTENT_CLASS, "']"));
        try {
            this.createScroller(this.mySelf, content);
        }
        catch (err) {
            this.scroller = null;
        }
    };
    BcScrollerBehavior.prototype.calculateScrollerHeight = function () {
        var visibleRatio = this.scrollContainer.offsetHeight / this.scrollContentWrapper.scrollHeight;
        return visibleRatio * this.scrollContainer.offsetHeight;
    };
    BcScrollerBehavior.prototype.moveScroller = function (evt) {
        var scrollPercentage = evt.target.scrollTop / this.scrollContentWrapper.scrollHeight;
        var size = 5;
        this.topPosition = scrollPercentage * (this.scrollContainer.offsetHeight - size);
        this.scroller.style.top = this.topPosition.toString() + 'px';
    };
    BcScrollerBehavior.prototype.startDrag = function (evt) {
        this.normalizedPosition = evt.pageY;
        this.contentPosition = this.scrollContentWrapper.scrollTop;
        this.scrollerBeingDragged = true;
    };
    BcScrollerBehavior.prototype.stopDrag = function (evt) {
        this.scrollerBeingDragged = false;
    };
    BcScrollerBehavior.prototype.scrollBarScroll = function (evt) {
        if (this.scrollerBeingDragged === true) {
            var mouseDifferential = evt.pageY - this.normalizedPosition;
            var scrollEquivalent = mouseDifferential * (this.scContenWrapperHeight / this.ofContainerHeight);
            this.scrollContentWrapper.scrollTop = this.contentPosition + scrollEquivalent;
        }
    };
    BcScrollerBehavior.prototype.createScroller = function (container, content) {
        var _this = this;
        this.scrollContainer = container;
        this.scrollContentWrapper = content;
        this.scrollerHeight = this.calculateScrollerHeight();
        if (this.scrollerHeight / this.scrollContainer.offsetHeight < 1) {
            this.scroller = document.createElement('div');
            this.scroller.style.height = this.scrollerHeight.toString() + 'px';
            this.scroller.classList.add(bc_scroller_constants_3.SCROLLER_CLASS);
            this.scrollContainer.appendChild(this.scroller);
            this.scrollContainer.classList.add(bc_scroller_constants_4.SHOW_SCROLL_CLASS);
            this.scroller.addEventListener('mousedown', function (evt) { return _this.startDrag(evt); });
            this.scrollContainer.addEventListener('mouseup', function (evt) { return _this.stopDrag(evt); });
            this.scrollContainer.addEventListener('mousemove', function (evt) { return _this.scrollBarScroll(evt); });
            this.scrollContentWrapper.addEventListener('scroll', function (evt) { return _this.moveScroller(evt); });
            return this.scroller;
        }
    };
    return BcScrollerBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcScrollerBehavior = BcScrollerBehavior;
